import { DataSender } from '../loaders'
/**
* ShareModal
*/

class ShareModal {
    constructor(target, data) {
        if(!target || !target.length || !data) {
            window.activeModalInstance = null;
            return;
        }

        // properties
        this.target = target;
        this.data = data;
        this.searching = false;
        this.searchTimeout = null;
        this.selectedFriendsIds = [];
        this.selectedFriendsCount = 0;

        // layout
        this.target.html(this.data.html);
        this.profilesList = this.target.find('.modal-body');
        this.searchInput = this.profilesList.find('.search').find('input');
        this.searchClear = this.profilesList.find('.search').find('a');
        this.profilesListForm = this.profilesList.find('form.list');
        this.profilesResultsForm = this.profilesList.find('form.results');
        this.shareSelectedButton = this.target.find('.modal-footer').find('.selected');
        this.shareAllButton = this.target.find('.modal-footer').find('.all');

        // texts
        this.texts = window.shareModalTexts;

        // init
        this.initModal();
    }

    initModal() {
        var that = this;

        this.searchInput.bind('input', { reference: this }, this.searchInputHandler);
        this.searchInput.bind('focus', { reference: this }, this.searchFocusHandler);
        this.searchInput.bind('blur', { reference: this }, this.searchBlurHandler);

        this.searchClear.bind('click', function() {
            that.searching = false;
            that.profilesListForm.show();
            that.profilesResultsForm.hide().html('');
            that.searchInput.val('').blur();
            return false;
        });

        if(this.data.moreFriends) {
            this.profilesList.bind('scroll', { reference: this }, this.scrollListHandler);
            this.profilesListHeight = this.profilesList[0].scrollHeight;
        }

        this.initCheckboxes();

        this.shareSelectedButton.bind('click', function() {
            that.share();
            return false;
        });

        if(this.shareAllButton.length) {
            this.shareAllButton.bind('click', function() {
                that.share(true);
                return false;
            });
        }
    }

    initCheckboxes() {
        this.profileCheckboxes = this.profilesListForm.find('input[name="profiles[]"]');
        this.profileCheckboxes.unbind('change', this.checkboxChangeHandler);
        this.profileCheckboxes.bind('change', { reference: this }, this.checkboxChangeHandler);

        for(var i in this.selectedFriendsIds) {
            this.profileCheckboxes.filter('input[value="' + this.selectedFriendsIds[i] + '"]').prop('checked', true);
        }
    }

    searchInputHandler(e) {
        var that = e.data.reference;

        window.clearTimeout(that.searchTimeout);
        that.searchTimeout = window.setTimeout(function() {
            var term = $.trim(that.searchInput.val());

            if(term.length) {
                that.searching = true;
                that.profilesListForm.hide();
                that.profilesResultsForm.show().html('<div class="activity-indicator gray"></div>');

                new DataSender({
                    data: {
                        id: that.data.id,
                        term: term
                    },
                    url: '/' + that.data.type + '/share/search/',

                    success: function(data) {
                        if(data.status) {
                            if(data.html.length) {
                                that.profilesResultsForm.html(data.html);

                                for(var i in that.selectedFriendsIds) {
                                    that.profilesResultsForm.find('input[value="' + that.selectedFriendsIds[i] + '"]').prop('checked', true);
                                }
                                that.profilesResultsForm.find('input[name="profiles[]"]').unbind('change').bind('change', { reference: that, reflectChanges: true }, that.checkboxChangeHandler);
                            }
                            else {
                                that.profilesResultsForm.html('<div class="no-results">' + that.texts.noResults + '</div>');
                            }
                        }
                    }
                });
            }
            else {
                that.searching = false;
                that.profilesListForm.show();
                that.profilesResultsForm.hide().html('');
            }
        }, 250);
    }

    searchFocusHandler(e) {
        var that = e.data.reference;
        that.profilesList.addClass('search-focused');
    }

    searchBlurHandler(e) {
        var that = e.data.reference;

        if(!$.trim(that.searchInput.val()).length) {
            that.profilesList.removeClass('search-focused');
        }

        that.searchInput.val($.trim(that.searchInput.val()));
    }

    checkboxChangeHandler(e) {
        var that = e.data.reference;
        var checkbox = $(e.target);
        var index = $.inArray(parseInt(checkbox.val()), that.selectedFriendsIds);
        var reflectChanges = e.data.reflectChanges;

        if(checkbox.is(':checked')) {
            if(index == -1) {
                that.selectedFriendsIds.push(parseInt(checkbox.val()));
                that.selectedFriendsCount++;

                if(reflectChanges) {
                    that.profileCheckboxes.filter('input[value="' + checkbox.val() + '"]').prop('checked', true);
                }
            }
        }
        else {
            if(index > -1) {
                that.selectedFriendsIds.splice(index, 1);
                that.selectedFriendsCount--;

                if(reflectChanges) {
                    that.profileCheckboxes.filter('input[value="' + checkbox.val() + '"]').prop('checked', false);
                }
            }
        }

        if(!that.selectedFriendsCount) {
            that.shareSelectedButton.addClass('disabled');
            that.shareSelectedButton.text(that.texts.none);
        }
        else {
            that.shareSelectedButton.removeClass('disabled');
            that.shareSelectedButton.text(((that.selectedFriendsCount == 1) ? that.texts.singular : that.texts.plural).replace(/%d/, that.selectedFriendsCount));
        }
    }

    scrollListHandler(e) {
        var that = e.data.reference;

        if(!that.searching && that.profilesList.scrollTop() >= that.profilesListHeight - 250 - 100) {
            that.profilesList.unbind('scroll', that.scrollListHandler);
            that.loadMoreFriends();
        }
    }

    loadMoreFriends() {
        var that = this;

        new DataSender({
            data: { id: this.data.id },
            url: '/' + this.data.type + '/share/more-friends/',

            success: function(data) {
                that.profilesListForm.append(data.html);
                that.initCheckboxes();

                if(data.more) {
                    that.profilesList.bind('scroll', { reference: that }, that.scrollListHandler);
                    that.profilesListHeight = that.profilesListForm[0].scrollHeight;
                }
            }
        });
    }

    share(all) {
        var that = this;
        var shareWith = null;

        if(all && this.shareAllButton.length) {
            shareWith = 'all';
        }
        else if(this.selectedFriendsCount) {
            shareWith = this.selectedFriendsIds.join(',');
        }

        if(shareWith) {
            this.target.html('<div class="loader"><i class="fas fa-circle-notch fa-spin"></i></div>');

            new DataSender({
                data: {
                    id: this.data.id,
                    friends: shareWith
                },
                url: '/' + this.data.type + '/share/send/',

                success: function(data) {
                    if(data.status) {
                        that.target.html('<div class="success"></div>');
                    }

                    window.setTimeout(function() {
                        that.target.hide();

                        if(that.data.callback) {
                            that.data.callback({ status: true });
                        }
                    }, 750);
                },

                error: function() {
                    window.setTimeout(function() {
                        that.target.hide();

                        if(that.data.callback) {
                            that.data.callback({ status: true });
                        }
                    }, 750);
                }
            });
        }
    }
}

export { ShareModal }
